import config from "../../config"
import RequestService from "../RequestService"

const createTicketNote = (ticketId, params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/ticket_notes`, { ticket_note: { ticket_id: ticketId, ...params }}, successCallback, failureCallback)
}

export default createTicketNote;